export default __webpack_public_path__ + "static/media/countArrow.62372888.svg";